export default __webpack_public_path__ + "static/media/added.0207473b.svg";